/**
 * WordPress dependencies.
 */
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import {
	dispatch,
	select,
} from '@wordpress/data';

const minifyCss = ( css ) => {
	css = css.replace( ' ', '' );
	css = css.replace( /\t+/g, '' );
	css = css.replace( /(\r\n|\n|\r)/gm, '' );
	css = css.trim();
	return css;
};

const appendStyle = ( style, clientID ) => {
	const elementId = `gutenify-block-${ clientID }`;
	const element = document.getElementById( elementId );
	if ( typeof ( element ) === 'undefined' || element === null ) {
		const $style = document.createElement( 'style' );
		document.head.appendChild( $style );
		$style.setAttribute( 'rel', 'stylesheet' );
		$style.setAttribute( 'type', 'text/css' );
		$style.setAttribute( 'id', elementId );
		$style.innerHTML = style;
	} else {
		element.innerHTML = style;
	}
};

const generateCustomStyles = ( data, clientID, block ) => {
	const wrapperId = `#gutenify-section-${ clientID }`;
	const wrapperBackgroundColor = has( data, `backgroundColor` ) && '' !== data.backgroundColor ? data.backgroundColor : '';
	const wrapperBackgroundGradient = isEmpty( wrapperBackgroundColor ) && has( data, `backgroundGradient` ) && ! isEmpty( data.backgroundGradient ) ? data.backgroundGradient : '';

	const wrapperTextColor = has( data, `textColor` ) && '' !== data.textColor ? data.textColor : '';
	let style = '';

	// wrapperBackgroundColor = has( data, 'background' ) && ! isEmpty( data.background ) ? data.background : wrapperBackgroundColor;
	// wrapperTextColor = has( data, 'text' ) && ! isEmpty( data.text ) ? data.text : wrapperTextColor;

	const paddingUnit = '';//has( data, `padding.unit` ) ? data.padding.unit : 'px';
	const marginUnit = '';// has( data, `margin.unit` ) ? data.margin.unit : 'px';

	style += `${ wrapperId }{
		${ ! isEmpty( wrapperBackgroundColor ) ? `background-color: ${ wrapperBackgroundColor };` : '' }
		${ ! isEmpty( wrapperBackgroundGradient ) ? `background: ${ wrapperBackgroundGradient };` : '' }
		${ ! isEmpty( wrapperTextColor ) ? `color: ${ wrapperTextColor };` : '' }

		${ has( data, `padding.desktop.top` ) && ! isEmpty( data.padding.desktop.top ) ? `padding-top: ${ data.padding.desktop.top }${ paddingUnit };` : '' }
		${ has( data, `padding.desktop.right` ) && ! isEmpty( data.padding.desktop.right ) ? `padding-right: ${ data.padding.desktop.right }${ paddingUnit };` : '' }
		${ has( data, `padding.desktop.bottom` ) && ! isEmpty( data.padding.desktop.bottom ) ? `padding-bottom: ${ data.padding.desktop.bottom }${ paddingUnit };` : '' }
		${ has( data, `padding.desktop.left` ) && ! isEmpty( data.padding.desktop.left ) ? `padding-left: ${ data.padding.desktop.left }${ paddingUnit };` : '' }

		${ has( data, `margin.desktop.top` ) && ! isEmpty( data.margin.desktop.top ) ? `margin-top: ${ data.margin.desktop.top }${ marginUnit };` : '' }
		${ has( data, `margin.desktop.right` ) && ! isEmpty( data.margin.desktop.right ) ? `margin-right: ${ data.margin.desktop.right }${ marginUnit };` : '' }
		${ has( data, `margin.desktop.bottom` ) && ! isEmpty( data.margin.desktop.bottom ) ? `margin-bottom: ${ data.margin.desktop.bottom }${ marginUnit };` : '' }
		${ has( data, `margin.desktop.left` ) && ! isEmpty( data.margin.desktop.left ) ? `margin-left: ${ data.margin.desktop.left }${ marginUnit };` : '' }
	}`;

	// Wrapper media query for tablet.
	style += `@media only screen and (max-width: 992px) {
		${ wrapperId }{

			${ has( data, `padding.tablet.top` ) && ! isEmpty( data.padding.tablet.top ) ? `padding-top: ${ data.padding.tablet.top }${ paddingUnit };` : '' }
			${ has( data, `padding.tablet.right` ) && ! isEmpty( data.padding.tablet.right ) ? `padding-right: ${ data.padding.tablet.right }${ paddingUnit };` : '' }
			${ has( data, `padding.tablet.bottom` ) && ! isEmpty( data.padding.tablet.bottom ) ? `padding-bottom: ${ data.padding.tablet.bottom }${ paddingUnit };` : '' }
			${ has( data, `padding.tablet.left` ) && ! isEmpty( data.padding.tablet.left ) ? `padding-left: ${ data.padding.tablet.left }${ paddingUnit };` : '' }

			${ has( data, `margin.tablet.top` ) && ! isEmpty( data.margin.tablet.top ) ? `margin-top: ${ data.margin.tablet.top }${ marginUnit };` : '' }
			${ has( data, `margin.tablet.right` ) && ! isEmpty( data.margin.tablet.right ) ? `margin-right: ${ data.margin.tablet.right }${ marginUnit };` : '' }
			${ has( data, `margin.tablet.bottom` ) && ! isEmpty( data.margin.tablet.bottom ) ? `margin-bottom: ${ data.margin.tablet.bottom }${ marginUnit };` : '' }
			${ has( data, `margin.tablet.left` ) && ! isEmpty( data.margin.tablet.left ) ? `margin-left: ${ data.margin.tablet.left }${ marginUnit };` : '' }
		}
	}`;

	// Wrapper media query for mobile.
	style += `@media only screen and (max-width: 768px) {
		${ wrapperId }{

			${ has( data, `padding.mobile.top` ) && ! isEmpty( data.padding.mobile.top ) ? `padding-top: ${ data.padding.mobile.top }${ paddingUnit };` : '' }
			${ has( data, `padding.mobile.right` ) && ! isEmpty( data.padding.mobile.right ) ? `padding-right: ${ data.padding.mobile.right }${ paddingUnit };` : '' }
			${ has( data, `padding.mobile.bottom` ) && ! isEmpty( data.padding.mobile.bottom ) ? `padding-bottom: ${ data.padding.mobile.bottom }${ paddingUnit };` : '' }
			${ has( data, `padding.mobile.left` ) && ! isEmpty( data.padding.mobile.left ) ? `padding-left: ${ data.padding.mobile.left }${ paddingUnit };` : '' }

			${ has( data, `margin.mobile.top` ) && ! isEmpty( data.margin.mobile.top ) ? `margin-top: ${ data.margin.mobile.top }${ marginUnit };` : '' }
			${ has( data, `margin.mobile.right` ) && ! isEmpty( data.margin.mobile.right ) ? `margin-right: ${ data.margin.mobile.right }${ marginUnit };` : '' }
			${ has( data, `margin.mobile.bottom` ) && ! isEmpty( data.margin.mobile.bottom ) ? `margin-bottom: ${ data.margin.mobile.bottom }${ marginUnit };` : '' }
			${ has( data, `margin.mobile.left` ) && ! isEmpty( data.margin.mobile.left ) ? `margin-left: ${ data.margin.mobile.left }${ marginUnit };` : '' }
		}
	}`;

	if ( '' !== wrapperTextColor ) {
		if ( 'gutenify/team' === block.name ) {
			style += `${ wrapperId } .wp-block-gutenify-team-member p,
				${ wrapperId } .wp-block-gutenify-team-member h1,
				${ wrapperId } .wp-block-gutenify-team-member h2,
				${ wrapperId } .wp-block-gutenify-team-member h3,
				${ wrapperId } .wp-block-gutenify-team-member h4,
				${ wrapperId } .wp-block-gutenify-team-member h5,
				${ wrapperId } .wp-block-gutenify-team-member h6{
					color: ${ wrapperTextColor };
				}`;
		}
		if ( 'gutenify/team-member' === block.name ) {
			// Frontend
			let teamMemberClass = `
			.wp-block-gutenify-team  .wp-block-gutenify-team-member ${ wrapperId }`;

			style += `${ teamMemberClass } p,
				${ teamMemberClass } h1,
				${ teamMemberClass } h2,
				${ teamMemberClass } h3,
				${ teamMemberClass } h4,
				${ teamMemberClass } h5,
				${ teamMemberClass } h6{
					color: ${ wrapperTextColor };
				}`;
			// Admin.
			teamMemberClass = `.gutenify-admin-team-block-wrapper ${ wrapperId }.wp-block-gutenify-team-member`;

			style += `${ teamMemberClass } p,
				${ teamMemberClass } h1,
				${ teamMemberClass } h2,
				${ teamMemberClass } h3,
				${ teamMemberClass } h4,
				${ teamMemberClass } h5,
				${ teamMemberClass } h6{
					color: ${ wrapperTextColor };
				}`;
		}
	}

	return style;
};

const generateCustomStyleCode = ( data, block, updateMeta = false ) => {
	const {
		getBlock,
	} = select( 'core/block-editor' );

	const filterStyleData = {};
	let styles = '';
	let frontStyles = '';

	const {
		getCustomStylesData,
	} = select( 'Gutenify/store' );
	let styleData = getCustomStylesData();

	styleData = {
		...styleData,
		[ block.clientId ]: data,
	};

	for ( const _clientID in styleData ) {
		if ( styleData.hasOwnProperty( _clientID ) ) {
			const blockData = getBlock( _clientID );
			if ( null !== blockData ) {
				styleData[ _clientID ].background = has( blockData, `attributes.style.color.background` ) ? blockData.attributes.style.color.background : '';
				styleData[ _clientID ].text = has( blockData, `attributes.style.color.text` ) ? blockData.attributes.style.color.text : '';
				const _style = generateCustomStyles( styleData[ _clientID ], _clientID, blockData );
				styles += _style;
				const blockClientId = has( blockData, `attributes.blockClientId` ) && ! isEmpty( blockData.attributes.blockClientId ) ? blockData.attributes.blockClientId : _clientID;
				const _frontStyle = generateCustomStyles( styleData[ _clientID ], blockClientId, blockData );
				frontStyles += _frontStyle;

				filterStyleData[ _clientID ] = styleData[ _clientID ];
				appendStyle( _style, _clientID );
			}
		}
	}

	const {
		updateCustomStylesData,
	} = dispatch( 'Gutenify/store' );
	updateCustomStylesData( styleData );

	if ( updateMeta ) {
		const {
			editPost,
		} = dispatch( 'core/editor' );
		editPost( {
			meta: {
				gutenify_custom_css: minifyCss( frontStyles ),
				// gutenify_custom_css_data: JSON.stringify( styleData ),
			},
		} );
	}

	return styles;
};

export {
	generateCustomStyleCode,
};
